import moduleLayout from "@/view/bankAc/layout.vue";

export default {
    path: "/payment",
    component: moduleLayout,
    redirect: "/payment/list",
    name: "paymentList",
    children: [
        {
            path: "list",
            name: "PaymentList",
            component: () => import("@/view/payment/paymentlist/index.vue")
        }, 
        {
            path: "email-preview",
            name: "emailPreview",
            component: () => import("@/view/payment/paymentlist/emailPreview.vue")
        }, 
        {
            path: "payment-reminder",
            name: "paymentReminderPreview",
            component: () => import("@/view/payment/paymentlist/paymentReminderPreview.vue")
        }, 
         
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/payment.js